import GsuLoader from '@/components/GsuLoader'
import { useAi } from '@/context/ai'
import { useFeatureToggle } from '@/context/featureToggles'
import { Partner } from '@/shared/api-generated-types'
import Chat from '@/widgets/v2/AI/Chat'
import ComingSoon from '@/widgets/v2/AI/ComingSoon'
import Search from '@/widgets/v2/AI/Search'
import { gql, useQuery } from 'urql'

interface Props {
  authToken?: string
  partnerId?: string
  sandboxMode?: boolean
  hideIntroVideo?: boolean
}

const QUERY_PARTNER_INFO = gql`
  query partnerInfo {
    partnerInfo {
      id
      helenEnabled
    }
  }
`

const Container = (props: Props): JSX.Element => {
  const { state } = useAi()
  const [{ data, fetching }] = useQuery<{ partnerInfo: Partner }>({
    query: QUERY_PARTNER_INFO,
    requestPolicy: 'cache-first',
  })

  // Show coming soon message if helen_tab flag has been disabled in ConfigCat
  // OR the Helen has been disabled for the current partner
  const showHelenTab = useFeatureToggle('helen_tab')
  if (!showHelenTab || fetching || (data?.partnerInfo?.id && !!data?.partnerInfo?.helenEnabled === false))
    return (
      <section className="p-4 sm:pl-8 sm:pr-8 lg:pl-12 lg:pr-12 xxl:pl-16 xxl:pr-16">
        <div className={`text-center min-h-[50vh] flex item-center justify-center`}>
          {fetching ? <GsuLoader /> : <ComingSoon />}
        </div>
      </section>
    )

  return state.query.length ? (
    <Chat authToken={props.authToken} partnerId={props.partnerId} sandboxMode={props.sandboxMode} />
  ) : (
    <Search partnerId={props.partnerId} hideIntroVideo={props.hideIntroVideo} />
  )
}

export default Container
